import React, { useEffect } from 'react';

/**
 * 공용 Bottom Sheet 컴포넌트
 * - drag handle + overlay 포함
 * - CSS transform/transition 기반 (no external animation lib)
 */
export default function BottomSheet({ open, onClose, title, subHeader, children }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.4)',
          zIndex: 1000,
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',
          transition: 'opacity 0.25s ease',
        }}
      />

      {/* Sheet */}
      <div
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1001,
          background: '#fff',
          borderRadius: '20px 20px 0 0',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          boxSizing: 'border-box',
          transform: open ? 'translateY(0)' : 'translateY(100%)',
          transition: 'transform 0.3s cubic-bezier(0.32, 0.72, 0, 1)',
        }}
      >
        {/* Fixed: drag handle + header + subHeader */}
        <div style={{ flexShrink: 0 }}>
          {/* Drag handle */}
          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 12, paddingBottom: 4 }}>
            <div style={{ width: 36, height: 4, borderRadius: 2, background: '#d1d5db' }} />
          </div>

          {/* Header */}
          {title && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '8px 20px 12px',
              borderBottom: '1px solid #f3f4f6',
            }}>
              <span style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>{title}</span>
              <button
                onClick={onClose}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: 20,
                  color: '#9ca3af',
                  padding: 4,
                  lineHeight: 1,
                }}
              >
                ×
              </button>
            </div>
          )}

          {/* Sub-header (고정) */}
          {subHeader && (
            <div style={{ padding: '8px 20px 12px', borderBottom: '1px solid #f3f4f6' }}>
              {subHeader}
            </div>
          )}
        </div>

        {/* Scrollable content */}
        <div style={{ overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', flexGrow: 1 }}>
          <div style={{ padding: '16px 20px calc(24px + env(safe-area-inset-bottom, 0px))', boxSizing: 'border-box' }}>
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
